import actionTypes from './index';

export default () => ({
  type: actionTypes.MOUNT_TYPES,
  payload: {
    inside: 'Inside',
    outside: 'Outside',
  },
});
